import React from "react";
import BasePage from "../../base/BasePage";
import InputFactory from "../../components/InputFactory";
import withRouter from "../../withRouter";
import { updateObjectUseCase } from "../../usecases/object";
import {
  isStrongPassword,
  passwordInputProps,
  passwordStrength,
  PASSWORD_TITLE,
} from "../../components/InputFactory/passwordPolicy";
import PublicAuthFrame from "../forgot/PublicAuthFrame";
import ResetPresenter from "./ResetPresenter";

class ResetPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new ResetPresenter(this, updateObjectUseCase());
    this.state = { password: {}, ready: false, progress: false };
  }

  getToken() {
    return this.getParams()?.token;
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  onSubmitPassword(e) {
    e.preventDefault();
    this.presenter.onSubmitPassword(this.state.password);
  }

  onChange(value, field) {
    this.setState((prevState) => ({
      password: {
        ...prevState.password,
        [field]: value,
      },
    }));
  }

  setCurrentUsers() {
    this.setState({ ready: true });
  }

  render() {
    if (!this.state.ready) {
      return (
        <PublicAuthFrame title="Reset your password">
          <p className="text-center text-muted mb-0">Checking your link...</p>
        </PublicAuthFrame>
      );
    }

    const { newPassword = "", confirmNewPassword = "" } = this.state.password;
    const strength = passwordStrength(newPassword);
    const confirmMismatch =
      confirmNewPassword.length > 0 && newPassword !== confirmNewPassword;
    const canSubmit =
      isStrongPassword(newPassword) &&
      newPassword === confirmNewPassword &&
      !this.state.progress;

    return (
      <PublicAuthFrame title="Reset your password">
        <p className="text-muted mb-3">{PASSWORD_TITLE}.</p>
        <form onSubmit={this.onSubmitPassword.bind(this)}>
          <div className="mb-3">
            <label className="form-label">New Password</label>
            <InputFactory
              className="form-control"
              type="Password"
              field="newPassword"
              required
              {...passwordInputProps()}
              onChange={this.onChange.bind(this)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Confirm Password</label>
            <InputFactory
              className="form-control"
              type="Password"
              field="confirmNewPassword"
              required
              placeholder="Re-type the new password"
              onChange={this.onChange.bind(this)}
            />
            {confirmMismatch && (
              <div className="text-danger fs-sm mt-1">
                Password must be the same.
              </div>
            )}
          </div>
          <ul className="list-unstyled mb-3">
            {strength.rules.map((rule) => (
              <li key={rule.id} className="d-flex gap-2 mb-1">
                <i
                  className={
                    rule.met ? "bi bi-check-circle-fill" : "bi bi-circle"
                  }
                  style={{ color: rule.met ? "#22c55e" : "#9ca3af" }}
                  aria-hidden="true"
                />
                <span>{rule.label}</span>
              </li>
            ))}
          </ul>
          <div className="text-center">
            <button
              className="btn text-white w-100"
              type="submit"
              style={{ backgroundColor: "#29457c", borderRadius: "5px" }}
              disabled={!canSubmit}
            >
              RESET
            </button>
          </div>
        </form>
      </PublicAuthFrame>
    );
  }
}

export default withRouter(ResetPage);
